import {
  HttpEvent,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  DoNotSendCredentialsHeader,
  SkipInterceptHeader,
} from '@corezilla/api';

export const globalHttpInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  let headers = request.headers;
  const withCredentials = !headers.has(DoNotSendCredentialsHeader);
  if (!withCredentials) headers = headers.delete(DoNotSendCredentialsHeader);

  const shouldSkipIntercept = headers.has(SkipInterceptHeader);
  if (shouldSkipIntercept) headers = headers.delete(SkipInterceptHeader);
  else headers = headers.set('Content-Type', 'application/ld+json');

  request = request.clone({ withCredentials, headers });
  return next(request);
};
